import React, { useState } from "react";
import { Container, Col, Row, Button } from 'react-bootstrap';
import { useAuth0 } from "@auth0/auth0-react";
import CountdownTimer from './CountdownTimer';
import axios from 'axios';

import '../css/Profile.css';

const Profile = () => {
  
  const [showResult, setShowResult] = useState(false);
  const [apiMessage, setApiMessage] = useState("");
  const [clipboardCopied, setClipboarCopied] = useState(false);
  const [resetTimer, setResetTimer] = useState(0)
  const { getAccessTokenSilently, loading, user } = useAuth0();
  
  const copyTokenToClipboard = async (token) => {
    navigator.clipboard.writeText(token).then(function () {
      setClipboarCopied(true);
    }, function () {
      console.log("Cannot copy to clipboard?!");
    });
  }

  const obtainToken = async () => {
    try {
      const token = await getAccessTokenSilently();

      var apiEndpoint = process.env.REACT_APP_TROVE_SERVICE;
      // use axios to fetch the character from the api:
      const options = {
        url: apiEndpoint + '/Account/GetAssociationToken',
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      };

      console.log("Contacting API: " + options.url);

      let responseData = await axios.post(options.url, options, options)
        .then((res) => {
          console.log("Res: " + res.data.nonce)
          return res.data.nonce
        }, (error) => {
          console.log(error);
        });

      if (responseData !== undefined) {
        setResetTimer(resetTimer + 1)
        setClipboarCopied(false);
        setApiMessage(responseData);
        setShowResult(true);
      }
    } catch (error) {
      setApiMessage("Error!");
      setShowResult(true);
      console.error(error);
    }
  }

  if (loading || !user) {
    return <div>Loading...</div>;
  }

  

  return (
    <Container>
      <Col>
        <Container>
          <Row>
            <img src={user.picture} alt={user.name} /><div><h2>User: {user.name}<br />Email: {user.email}</h2></div>
          </Row>
        </Container>
        <Container>
          <p>DDO Account Claim:</p>
          <ul>
            <li>Private characters are not visible to the public and must be associated with a website account to become visible to you.</li>
            <li>Once your account is associated, all of the uploaded characters on your account will be visible within the dashboard of this website.</li>
            <li>Since you're logged-in, you can now attempt to associate a DDO account by obtaining a token below.</li>
            <li>Once you have obtained a token (by clicking the button below), enter the token into your Trove Plugin.</li>
          </ul>
          <Button variant="dark" onClick={obtainToken}>Obtain temporary Account Token (expires after 10 minutes)</Button>
          {showResult ?
            <div className="token">
              <code>{apiMessage}</code>
              <Button className="clipboard" variant="dark" onClick={() => copyTokenToClipboard(apiMessage)}> {clipboardCopied ? <span>copied!</span> : <span>Copy to Clipboard</span>}</Button>
              <div className="countdown">
                <CountdownTimer lastResetTimer={resetTimer} />
              </div>
            </div>
            : null}
        </Container>
      </Col>
    </Container>
  );
};

export default Profile;